import { tr } from "../i18n";

/**
 * Subcategories, for the categories where "device" or "kit" alone doesn't say
 * enough to browse by. Puffs and pods vary by brand instead — that's what the
 * brand field is for — so those categories have no entry here.
 */
const VALUES = {
  device: ["box", "accu", "atomizer"],
  kit: ["mech", "coil"],
  accessory: ["box_protection", "ring", "drip_tube", "accu_charger", "pyrex"],
};

export const hasSubcategories = (category) => Boolean(VALUES[category]);

export const subcategoryLabel = (category, value) => {
  const key = `common.subcategories.${category}.${value}`;
  const label = tr(key);
  return label === key ? value : label;
};

export const subcategoriesFor = (category) =>
  (VALUES[category] || []).map((value) => ({
    value,
    get label() {
      return subcategoryLabel(category, value);
    },
  }));
